export const sortAZSelectOptions = (options = []) => options.sort((a, b) => a?.label?.localeCompare(b.label) || true)